"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const colors_1 = require("../colors");
const custom_1 = require("./custom");
exports.theme = custom_1.createThemeFromColor('#F9F8FA', 'light-purple', 'Tím nhạt', {
    override: {
        primaryBackgroundColor: colors_1.getStaticColors({ isDark: false }).purple,
    },
});
//# sourceMappingURL=light-purple.js.map